import { render } from "./UpdateDocumentModal.vue?vue&type=template&id=324d8e24"
import script from "./UpdateDocumentModal.vue?vue&type=script&lang=js"
export * from "./UpdateDocumentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__